import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-08d3ac3b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "family-dot"
}
const _hoisted_2 = {
  key: 1,
  class: "horizontal-bar"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "vertical-bar" }, null, -1))
const _hoisted_4 = {
  key: 2,
  class: "horizontal-bar"
}

import { PropType } from 'vue';



export default /*#__PURE__*/_defineComponent({
  __name: 'ParentConnector',
  props: {
  mother: Boolean,
  layout: String as PropType<"small" | "tiny" | "dot">,
  dimmed: Boolean,
},
  setup(__props) {

const props = __props;




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["parent-connector", { mother: props.mother }])
  }, [
    (!props.mother)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1))
      : _createCommentVNode("", true),
    (!props.mother)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2))
      : _createCommentVNode("", true),
    _hoisted_3,
    (props.mother)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4))
      : _createCommentVNode("", true)
  ], 2))
}
}

})